import { render, staticRenderFns } from "./CourseSquareCard.vue?vue&type=template&id=38bf35fc&"
import script from "./CourseSquareCard.vue?vue&type=script&lang=js&"
export * from "./CourseSquareCard.vue?vue&type=script&lang=js&"
import style0 from "./CourseSquareCard.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports